import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface LifeCounterProps {
  lives: number;
}

const LifeCounter: React.FC<LifeCounterProps> = ({ lives }) => {
  if (lives === 0) return null;

  const stars = Math.floor(lives / 10);
  const hearts = lives % 10;

  return (
    <div
      className="fixed top-4 right-4 px-4 py-2 rounded-lg font-theme font-bold text-xl flex items-center space-x-3 shadow-lg"
      style={{
        backgroundColor: 'var(--color-bg-secondary)',
        borderColor: 'var(--color-primary)',
        borderWidth: '2px',
        borderStyle: 'solid',
        color: 'var(--color-text)',
        zIndex: 9999
      }}
    >
      {stars > 0 && (
        <div className="flex items-center space-x-2">
          <span style={{ fontSize: '1.2em' }}>⭐</span>
          <AnimatePresence mode="wait">
            <motion.span
              key={`star-${stars}`}
              initial={{ scale: 1.5 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3 }}
              className="text-gradient"
            >
              ×{stars}
            </motion.span>
          </AnimatePresence>
        </div>
      )}
      {hearts > 0 && (
        <div className="flex items-center space-x-2">
          <span>❤️</span>
          <AnimatePresence mode="wait">
            <motion.span
              key={`heart-${hearts}`}
              initial={{ scale: 1.5 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.3 }}
              className="text-gradient"
            >
              ×{hearts}
            </motion.span>
          </AnimatePresence>
        </div>
      )}
    </div>
  );
};

export default LifeCounter;
